import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// tailwind-merge musi znać własne rozmiary tekstu (text-h3, text-caption…), inaczej pomyli je z kolorami.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        { text: ['h2', 'h3', 'h4', 'body-m', 'body-s', 'label', 'caption', 'overline', 'micro', 'avatar'] },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
